import React from "react";
import { Form } from "react-bootstrap";

const SingleSelect = ({
    name,
    label,
    options = [],
    value,
    onChange,
    placeholder = "-- Select --",
    error = false,
    disabled = false,
    size = "sm",
    className = "",
    ...props
}) => {
    const handleChange = (e) => {
        if (onChange) {
            onChange(name, e.target.value);
        }
    };

    return (
        <Form.Group controlId={`form-${name}`} className={className}>
            {label && <Form.Label>{label}</Form.Label>}
            <Form.Control
                as="select"
                name={name}
                size={size}
                value={value || ""}
                onChange={handleChange}
                disabled={disabled}
                isInvalid={error}
                {...props}
            >
                <option value="">{placeholder}</option>
                {options.map((option) => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </Form.Control>
            {error && (
                <div style={{ color: "#dc3545", fontSize: "12px", marginTop: "4px" }}>
                    This field is required
                </div>
            )}
        </Form.Group>
    );
};

export default SingleSelect;
